import { create } from 'zustand';
import { useTokenStore } from './setTokenStore';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { AuthApi, type CodeRequest, type LoginResponse } from '@shared/api';

interface CodeType {
  loading: boolean;
  error: string | null;
  userData: LoginResponse | null;
  success: boolean | null;
  verifyCode: (request: CodeRequest, signal?: AbortSignal) => Promise<void>;
  resetErrors: () => void;
  clear: () => void;
}

export const useVerifyCodeStore = create<CodeType>((set) => ({
  userData: null,
  error: null,
  success: false,
  loading: false,

  verifyCode: ApiUtils.wrapperApi(async (data) => {
    try {
      set({ success: false, error: null, loading: true });
      const response = await AuthApi.verifyCode(data);
      if (response.token) useTokenStore.getState().setToken(response.token);
      set({
        success: true,
        userData: response,
        loading: false,
      });
    } catch (error) {
      set({ success: null, error: ApiUtils.getApiError(error), loading: false });
      throw error;
    }
  }, RequestStrategyEnum.Debounce),

  resetErrors: () => set({ error: null }),

  clear: () => set({ userData: null, error: null, success: false, loading: false }),
}));
